import dayjs from 'dayjs';
import 'dayjs/locale/id';

import formatTimeAgo from '@src/helper/formatTime';

const CLOSING_SOON_DAYS = 7;

// "2026-10-07 15:03:02 +0700" -> "2026-10-07T15:03:02+07:00" (aman untuk semua browser)
const toIsoDate = (value) =>
  value?.replace(/^(\S+) (\S+) ([+-]\d{2})(\d{2})$/, '$1T$2$3:$4');

const toParagraphs = (text) =>
  (text ?? '')
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

const formatJobVacancy = (job) => {
  if (!job) return null;

  const [salaryMin, salaryMax] = (job.salary_range ?? '')
    .split('-')
    .map((value) => Number(value.trim()) || null);

  const deadline = job.application_deadline ? dayjs(job.application_deadline) : null;
  const daysLeft = deadline ? deadline.endOf('day').diff(dayjs(), 'day') : null;

  return {
    id: job.id,
    title: job.title,
    location: job.office_location,
    workType: job.work_type,
    employmentType: job.employment_type,
    salaryMin,
    salaryMax,
    postedAt: job.published_at ? `Diposting ${formatTimeAgo(toIsoDate(job.published_at))}` : '',
    deadline: deadline ? `Batas: ${deadline.locale('id').format('D MMM YYYY')}` : '',
    isClosingSoon: daysLeft !== null && daysLeft >= 0 && daysLeft <= CLOSING_SOON_DAYS,
    description: toParagraphs(job.description),
    requirements: toParagraphs(job.requirements),
    company: job.company,
  };
};

export default formatJobVacancy;
